import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { DatePicker } from "@mui/x-date-pickers";
import { useToastContext } from "components/alert/ToastContext";
import BaseCadastro from "components/BaseCadastro";
import { Label } from "components/input/Label";
import ModalSelecaoPeriodicidadeIndicador from "components/modal/periodicidade/ModalSelecaoPeriodicidadeIndicador";
import dayjs from "dayjs";
import Usuario from "model/administracao/cadastro/Usuario";
import Indicador from "model/indicadores/Indicador";
import { IndicadorMeta } from "model/indicadores/IndicadorMeta";
import Processo from "model/indicadores/Processo";
import UnidadeOrganizacional from "model/indicadores/UnidadeOrganizacional";
import { Button } from "primereact/button";
import { Checkbox } from "primereact/checkbox";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dropdown } from "primereact/dropdown";
import { InputNumber } from "primereact/inputnumber";
import { InputText } from "primereact/inputtext";
import { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import IndicadorService from "service/indicadores/IndicadorService";
import { PeriodicidadeService } from "service/periodicidade/PeriodicidadeService";

const indicadorService = new IndicadorService();
const periodicidadeService = new PeriodicidadeService();

export default function IndicadorCadastro() {

    const [processos, setProcessos] = useState<Processo[]>([]);
    const [unidadesOrgan, setUnidadesOrgan] = useState<UnidadeOrganizacional[]>([]);
    const [usuarios, setUsuarios] = useState<Usuario[]>([]);
    const [indicador, setIndicador] = useState<Indicador>(new Indicador());
    const [dialogPediodicidade, setDialogPediodicidade] = useState<{ visible: boolean, data: any, originalData: any, campo: "periodicidadeAnalise" | "periodicidadeColeta" }>({ visible: false, data: null, originalData: null, campo: "periodicidadeColeta" });
    const [titulo, setTitulo] = useState<string>('Indicador');

    const { msgAlerta } = useToastContext();

    const { register, control, handleSubmit, setFocus, clearErrors, setError, formState: { errors } } = useForm();

    useEffect(() => {

        indicadorService.processos().then(resposta => {
            setProcessos(resposta);
        });

        indicadorService.unidadesOrgan().then(resposta => {
            setUnidadesOrgan(resposta);
        });

        indicadorService.usuarios().then(resposta => {
            setUsuarios(resposta);
        });

    }, [])

    function validarPersonalizado() {
        let dataFinal = null;
        for (let i = 0; i < indicador.metas.length; i++) {
            if (indicador.metas[i].dataInicio === null) {
                msgAlerta("Alerta", "Data de início da meta é obrigatória");
                return false;
            }
            if (indicador.metas[i].dataFim === null && i != indicador.metas.length - 1) {
                msgAlerta("Alerta", "Data de fim da meta é obrigatória no item " + (i + 1));
                return false;
            }
            if (indicador.metas[i].tipo === null) {
                msgAlerta("Alerta", "Tipo da meta é obrigatório");
                return false;
            }
            if (indicador.metas[i].meta === null) {
                msgAlerta("Alerta", "Valor da meta é obrigatório");
                return false;
            }
            if (indicador.metas[i].dataFim && (indicador.metas[i].dataFim as Date) <= (indicador.metas[i].dataInicio as Date)) {
                msgAlerta("Alerta", "Data de fim da meta deve ser maior que a data de início");
                return false;
            }
            if (dataFinal && dataFinal >= (indicador.metas[i].dataInicio as Date)) {
                msgAlerta("Alerta", "Data de início da meta deve ser maior que a data de fim da meta anterior");
                return false;
            }
            dataFinal = indicador.metas[i].dataFim;
        }
        return true;
    }

    function validar() {
        if (!indicador.codigo) {
            setError("codigo", { type: "manual", message: "Código é obrigatório." }, { shouldFocus: true });
            return false;
        }
        if (!indicador.nome) {
            setError("nome", { type: "manual", message: "Nome é obrigatório." }, { shouldFocus: true });
            return false;
        }
        if (indicador.processo === null) {
            setError("processo", { type: "manual", message: "Processo é obrigatório" }, { shouldFocus: true })
            return false;
        }
        if (indicador.unidadeOrganizacional === null) {
            setError("unidadeOrganizacional", { type: "manual", message: "Unidade Organizacional é obrigatória" }, { shouldFocus: true })
            return false;
        }
        if (indicador.tipoAcumuloValor === null) {
            setError("tipoAcumuloValor", { type: "manual", message: "Tipo de acúmulo de valor é obrigatório" }, { shouldFocus: true })
            return false;
        }
        if (indicador.dataInicioColeta === null) {
            setError("dataInicioColeta", { type: "manual", message: "Data de início é obrigatória" }, { shouldFocus: true })
            return false;
        }
        if (indicador.periodicidadeColeta === null) {
            setError("periodicidadeColeta", { type: "manual", message: "Periodicidade de coleta é obrigatória" }, { shouldFocus: true })
            return false;
        }
        if (indicador.usuarioColeta === null) {
            setError("usuarioColeta", { type: "manual", message: "Responsável pela coleta é obrigatório" }, { shouldFocus: true })
            return false;
        }
        if (indicador.temAnalise) {
            if (indicador.usuarioAnalise === null) {
                setError("usuarioAnalise", { type: "manual", message: "Responsável pela análise é obrigatório" }, { shouldFocus: true })
                return false;
            }
        }

        return true;
    }

    const codigoKeyDown = (e: any) => {
        if (e.key === 'Enter') {
            if (!indicador.codigo) {
                indicadorService.proximoCodigo().then((data) => {
                    setIndicador({ ...indicador, codigo: data });
                    setFocus("nome");
                    clearErrors("codigo");
                }).catch((error) => {
                    console.log(error);
                });
            }
        }
    }



    return (
        <BaseCadastro model={indicador} service={indicadorService} setModel={(value: Indicador) => setIndicador(value)} validar={() => validar()} validarPersonalizado={() => validarPersonalizado()} pathCadastro={"/indicador"} urlService={"/indicador"} tituloPagina={titulo}>
            {dialogPediodicidade.visible ?
                <ModalSelecaoPeriodicidadeIndicador visible={dialogPediodicidade.visible} value={dialogPediodicidade.data[dialogPediodicidade.campo]}
                    onChange={(value) => {
                        dialogPediodicidade.data[dialogPediodicidade.campo] = value
                        clearErrors([dialogPediodicidade.campo])
                        setIndicador({ ...indicador, [dialogPediodicidade.campo]: value })
                    }}
                    onConfirm={() => {
                        setDialogPediodicidade({ visible: false, data: null, originalData: null, campo: "periodicidadeColeta" })
                    }}
                    onCancel={() => {
                        dialogPediodicidade.data[dialogPediodicidade.campo] = dialogPediodicidade.originalData[dialogPediodicidade.campo]
                        setIndicador({ ...indicador, [dialogPediodicidade.campo]: dialogPediodicidade.originalData[dialogPediodicidade.campo] })
                        setDialogPediodicidade({ visible: false, data: null, originalData: null, campo: "periodicidadeColeta" })
                    }}
                />
                : null}

            <div className="row">
                <Label className="col col-sm-12" obrigatorio>Código</Label>
                <div className="col-sm-12">
                    <InputText className={errors.codigo ? "p-invalid" : ""} onKeyDown={codigoKeyDown} value={indicador.codigo} style={{ width: '30%' }} {...register("codigo", {
                        onChange: (e) => {
                            clearErrors("codigo")
                            setIndicador({ ...indicador, codigo: e.target.value })
                        }
                    })} />
                </div>
                {errors.codigo && errors.codigo.message ? <span className='col-sm-12' style={{ color: "red" }} >{errors.codigo?.message as string}</span> : null}
            </div>

            <div className="row">
                <Label className="col col-sm-12" obrigatorio>Nome</Label>
                <div className="col-sm-12">
                    <InputText className={errors.nome ? "p-invalid" : ""} value={indicador.nome} style={{ width: '30%' }} {...register("nome", {
                        onChange: (e) => {
                            clearErrors("nome")
                            setIndicador({ ...indicador, nome: e.target.value })
                        }
                    })} />
                </div>
                {errors.nome && errors.nome.message ? <span className='col-sm-12' style={{ color: "red" }} >{errors.nome?.message as string}</span> : null}
            </div>

            <div className="row">
                <Label className="col col-sm-12">Unidade de medida</Label>
                <div className="col-sm-12">
                    <Controller name="unidadeMedida" control={control} render={({ field }) => (

                        <Dropdown
                            focusInputRef={field.ref}
                            className={errors.unidadeMedida ? "p-invalid" : ""}
                            options={indicadorService.getUnidadesMedida()}
                            optionLabel="label"
                            optionValue="value"
                            placeholder="Selecione"
                            value={indicador.unidadeMedida}
                            style={{ width: '30%' }}
                            onChange={(e) => {
                                clearErrors("unidadeMedida")
                                setIndicador({ ...indicador, unidadeMedida: e.value })
                            }
                            }
                        />
                    )} />
                </div>
                {errors.unidadeMedida && errors.unidadeMedida.message ? <span className='col-sm-12' style={{ color: "red" }} >{errors.unidadeMedida?.message as string}</span> : null}
            </div>

            <div className="row">
                <Label className="col col-sm-12">Tipo de acúmulo de valor (utilizado no relatório)</Label>
                <div className="col-sm-12">
                    <Controller name="tipoAcumuloValor" control={control} render={({ field }) => (

                        <Dropdown
                            focusInputRef={field.ref}
                            className={errors.tipoAcumuloValor ? "p-invalid" : ""}
                            options={indicadorService.getTiposAcumuloValor()}
                            optionLabel="label"
                            optionValue="value"
                            placeholder="Selecione"
                            value={indicador.tipoAcumuloValor}
                            style={{ width: '30%' }}
                            onChange={(e) => {
                                clearErrors("tipoAcumuloValor")
                                setIndicador({ ...indicador, tipoAcumuloValor: e.value })
                            }
                            }
                        />
                    )} />
                </div>
                {errors.tipoAcumuloValor && errors.tipoAcumuloValor.message ? <span className='col-sm-12' style={{ color: "red" }} >{errors.tipoAcumuloValor?.message as string}</span> : null}
            </div>

            <div className="row">
                <Label className="col col-sm-12" obrigatorio>Processo</Label>
                <div className="col-sm-12">
                    <Controller name="processo" control={control} render={({ field }) => (

                        <Dropdown
                            focusInputRef={field.ref}
                            className={errors.processo ? "p-invalid" : ""}
                            options={processos}
                            optionLabel="nome"
                            placeholder="Selecione"
                            value={indicador.processo}
                            style={{ width: '30%' }}
                            onChange={(e) => {
                                clearErrors("processo")
                                setIndicador({ ...indicador, processo: e.value as Processo })
                            }
                            }
                        />
                    )} />
                </div>
                {errors.processo && errors.processo.message ? <span className='col-sm-12' style={{ color: "red" }} >{errors.processo?.message as string}</span> : null}
            </div>

            <div className="row">
                <Label className="col col-sm-12" obrigatorio>Unidade Organizacional</Label>
                <div className="col-sm-12">
                    <Controller name="unidadeOrganizacional" control={control} render={({ field }) => (

                        <Dropdown
                            focusInputRef={field.ref}
                            className={errors.unidadeOrganizacional ? "p-invalid" : ""}
                            options={unidadesOrgan}
                            optionLabel="nome"
                            placeholder="Selecione"
                            value={indicador.unidadeOrganizacional}
                            style={{ width: '30%' }}
                            onChange={(e) => {
                                clearErrors("unidadeOrganizacional")
                                setIndicador({ ...indicador, unidadeOrganizacional: e.value as UnidadeOrganizacional })
                            }
                            }
                        />
                    )} />
                </div>
                {errors.unidadeOrganizacional && errors.unidadeOrganizacional.message ? <span className='col-sm-12' style={{ color: "red" }} >{errors.unidadeOrganizacional?.message as string}</span> : null}
            </div>

            <div className="row">
                <Label className="col-sm-12" obrigatorio>Data de início</Label>
                <div className="col-sm-12">
                    <Controller name="dataInicioColeta" control={control} render={({ field }) => (

                        <DatePicker
                            inputRef={field.ref}
                            value={dayjs(indicador.dataInicioColeta)}
                            format={"DD/MM/YYYY"}
                            onChange={value => {
                                clearErrors("dataInicioColeta")
                                setIndicador({ ...indicador, dataInicioColeta: value?.toDate() || null })
                            }}
                        />
                    )} />
                </div>
                {errors.dataInicioColeta && errors.dataInicioColeta.message ? <span className='col-sm-12' style={{ color: "red" }} >{errors.dataInicioColeta?.message as string}</span> : null}
            </div>

            <div style={{ display: "flex", width: "100%", marginTop: 8, marginLeft: -10 }}>
                <div style={{ flexDirection: "column", marginRight: 36 }}>
                    <Label obrigatorio>Periodicidade</Label>
                    <div >
                        <InputText className={errors.periodicidadeColeta ? "p-invalid" : ""} readOnly value={indicador.periodicidadeColeta?.ativa ?
                            indicador.periodicidadeColeta.personalizada ? "Personalizada" : indicador.periodicidadeColeta.periodo + " " + periodicidadeService.getTipoPeriodo(indicador.periodicidadeColeta.tipoPeriodo)?.label
                            : "Não informada"} />
                        <Button onClick={() => {
                            setDialogPediodicidade({ visible: true, data: indicador, originalData: JSON.parse(JSON.stringify(indicador)), campo: "periodicidadeColeta" });
                        }} icon={<FontAwesomeIcon icon="edit" />} />
                    </div>
                    {errors.periodicidadeColeta && errors.periodicidadeColeta.message ? <span className='col-sm-12' style={{ color: "red" }} >{errors.periodicidadeColeta?.message as string}</span> : null}
                </div>

                <div style={{ flexDirection: "column" }}>
                    <Label obrigatorio>Responsável</Label>
                    <div >
                        <Controller name="usuarioColeta" control={control} render={({ field }) => (

                            <Dropdown
                                focusInputRef={field.ref}
                                className={errors.usuarioColeta ? "p-invalid" : ""}
                                options={usuarios}
                                filter
                                optionLabel="nome"
                                placeholder="Selecione"
                                value={indicador.usuarioColeta}
                                style={{ width: '200px' }}
                                onChange={(e) => {
                                    clearErrors("usuarioColeta")
                                    setIndicador({ ...indicador, usuarioColeta: e.value as Usuario })
                                }}
                            />
                        )} />
                    </div>
                    {errors.usuarioColeta && errors.usuarioColeta.message ? <span className='col-sm-12' style={{ color: "red" }} >{errors.usuarioColeta?.message as string}</span> : null}
                </div>
            </div>
            <div style={{ display: "flex", width: "100%", marginTop: 8, marginLeft: -10, columnGap: 8, alignItems: "center" }}>
                <Checkbox checked={indicador.temMeta} onChange={(e) => setIndicador({ ...indicador, temMeta: e.checked as boolean })} />
                <Label className="col-sm-12">Tem meta?</Label>
            </div>

            {indicador.temMeta ? <div className="row">
                <div className="col-sm-12">
                    <DataTable value={indicador.metas}
                        reorderableRows
                        onRowReorder={(e) => {
                            setIndicador({ ...indicador, metas: e.value });
                        }}
                        header={<div style={{ display: "flex", justifyContent: "space-between", textAlign: 'center', alignContent: "center" }}>
                            <div></div>
                            <span style={{ textAlign: 'center', alignSelf: "center", position: 'relative' }}>Metas</span>
                            <div>
                                <Button
                                    type="button" icon={<FontAwesomeIcon icon="add" />}
                                    tooltip="Adicionar"
                                    tooltipOptions={{ position: "top" }} className="ui-button-info" onClick={() => setIndicador({ ...indicador, metas: [...(indicador.metas || []), new IndicadorMeta()] })}
                                ></Button>
                            </div>
                        </div>}
                        emptyMessage="Nenhum registro encontrado"
                    >

                        <Column rowReorder style={{ width: '3em' }} />
                        <Column field="dataInicio" header="Data de Início" style={{ maxWidth: 200 }} body={(rowData) =>
                            <DatePicker
                                value={dayjs(rowData.dataInicio)}
                                format={"DD/MM/YYYY"}
                                onChange={value => {
                                    rowData.dataInicio = value?.toDate() || null
                                    setIndicador({ ...indicador })
                                }}
                            />} />
                        <Column field="dataFim" header="Data de Fim" style={{ maxWidth: 200 }} body={(rowData) =>
                            <DatePicker
                                value={dayjs(rowData.dataFim)}
                                format={"DD/MM/YYYY"}
                                onChange={value => {
                                    rowData.dataFim = value?.toDate() || null
                                    setIndicador({ ...indicador })
                                }}
                            />} />
                        <Column field="tipo" header="Tipo" style={{ width: 200 }} body={(rowData) => <Dropdown
                            options={indicadorService.getTiposMeta()}
                            style={{ width: '100%' }}
                            value={rowData.tipo}
                            onChange={(e) => {
                                rowData.tipo = e.value as string
                                setIndicador({ ...indicador })
                            }}
                            optionLabel="label"
                            optionValue="value"
                        />} />
                        <Column field="meta" header="Valor" body={(rowData) => <InputNumber
                            locale="pt-BR"
                            value={rowData.meta}
                            style={{ width: '100%' }}
                            onChange={(e) => {
                                rowData.meta = e.value
                                setIndicador({ ...indicador })
                            }}
                        />} />
                        <Column
                            body={(rowData) => <Button
                                type="button" icon={<FontAwesomeIcon icon="trash" />}
                                tooltip="Remover"
                                tooltipOptions={{ position: "top" }} className="ui-button-danger" onClick={() => {
                                    const metas = [...indicador.metas]
                                    metas.splice(metas.indexOf(rowData), 1)
                                    setIndicador({ ...indicador, metas })
                                }} />}
                        />
                    </DataTable>
                </div>
            </div> : null}

            <div style={{ display: "flex", width: "100%", marginTop: 8, marginLeft: -10, columnGap: 8, alignItems: "center" }}>
                <Checkbox checked={indicador.temAnalise} onChange={(e) => setIndicador({ ...indicador, temAnalise: e.checked as boolean })} />
                <Label className="col-sm-12">Tem análise?</Label>
            </div>

            {indicador.temAnalise ? <div style={{ display: "flex", width: "100%", marginTop: 8, marginLeft: -10 }}>
                <div style={{ flexDirection: "column" }}>
                    <Label obrigatorio>Responsável pela análise</Label>
                    <div >
                        <Controller name="usuarioAnalise" control={control} render={({ field }) => (

                            <Dropdown
                                focusInputRef={field.ref}
                                className={errors.usuarioAnalise ? "p-invalid" : ""}
                                options={usuarios}
                                filter
                                optionLabel="nome"
                                placeholder="Selecione"
                                value={indicador.usuarioAnalise}
                                style={{ width: '200px' }}
                                onChange={(e) => {
                                    clearErrors("usuarioAnalise")
                                    setIndicador({ ...indicador, usuarioAnalise: e.value as Usuario })
                                }}
                            />
                        )} />
                    </div>
                    {errors.usuarioAnalise && errors.usuarioAnalise.message ? <span className='col-sm-12' style={{ color: "red" }} >{errors.usuarioAnalise?.message as string}</span> : null}
                </div>
            </div> : null}
        </BaseCadastro>
    )
}
